import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

//import "./i18n";

import 'react-toastify/dist/ReactToastify.css';

import App from "./App";
import './assets/scss/app.scss';
import "./assets/scss/Icons.scss";
import MonteflorProvider from "./hooks/useMonteflor.context";

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <BrowserRouter basename={"/"}>
    <MonteflorProvider>
      <App />
    </MonteflorProvider>
  </BrowserRouter>
);
